import { render, staticRenderFns } from "./OCIInfo.vue?vue&type=template&id=03a4e28b&"
import script from "./OCIInfo.vue?vue&type=script&lang=ts&"
export * from "./OCIInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OCIInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports